<template>
  <div class="role-manage-main">
    <div class="search-main">
      <el-form :inline="true"  class="demo-form-inline">
        <el-form-item label="角色名称">
          <el-input v-model="name"  placeholder="角色名称" clearable @change="getData">
          </el-input>
        </el-form-item>
        <el-form-item style="margin-right:20px">
          <el-button type="primary"  :icon="Search" @click="getData">查询</el-button>
        </el-form-item  >
        <el-form-item>
          <el-button type="primary"  :icon="CirclePlusFilled"  @click="$refs.roleAddOrUpdate.show()" >新建角色</el-button>
        </el-form-item>
      </el-form>
    </div>
    
    <div class="table-main">
        <el-table
          :data="tableData"
          style="width: 100%;"
          row-key="id"
          border
          height="calc(100% )"
          v-loading="loading"
        > 
        <el-table-column label="序号" width="55" type="index">
        </el-table-column>
        <el-table-column label="角色名称">
          <template #default="{row}">
            {{row.name}}
          </template>
        </el-table-column>
        <el-table-column label="启用" width="200">
          <template #default="{row}">
            <el-switch v-if="row.isEffective !== undefined" active-text="是" inactive-text="否" :active-value="1" :inactive-value="0" v-model="row.isEffective"
              inline-prompt :loading="row.loading" @change="isEffectiveChange(row)" :disabled="row.type!=2"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" >
          <template #default="{row}">
            <div v-if="row.isEffective !== undefined">
            <el-button type="text" @click="$refs.roleAddOrUpdate.show(row)" :disabled="row.type!=2" >编辑</el-button>
            <el-button type="text" @click="toDeleteRole(row)"  :disabled="row.type!=2">删除</el-button>
            <el-button type="text" @click="$refs.roleUserRef.show(row)"  :disabled="row.type!=2">人员</el-button>
            <el-button type="text" @click="$refs.setRolePower.show(row)"  >权限</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pages-main">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 50, 100, 500]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal">
        </el-pagination>
    </div>
    
  </div>
  <!-- <role-user ref="roleUser" /> -->
  <role-power ref="setRolePower" @get-data="getData" :orgs="orgs" />
  <add-or-update  ref="roleAddOrUpdate" @get-data="getData" />
  <role-user ref="roleUserRef"  />
</template>

<script>
import { defineComponent } from 'vue';
import RolePower from './RolePower.vue';
import AddOrUpdate from './AddOrUpdate.vue'
import RoleUser from './RoleUser.vue'
import { getList,del,isEffective } from '@/api/sys/role';

import {Search,CirclePlusFilled } from '@element-plus/icons-vue'
export default defineComponent({
  components: { RolePower, AddOrUpdate ,RoleUser},
  data() {
    return {
      Search,CirclePlusFilled,
      loading: false,
      //查询参数
      name:'',

      tableData: [],
      //分页对象
      currentPage:1,//当前页
      pageSize:20,//每页条数
      pageTotal:0,//总条数
     
      
    }
  },
  computed: {
    
  },
  mounted() {
    this.getData();

  },
  methods: {
    //`每页 ${val} 条`
    handleSizeChange(val) {
      this.pageSize=val;
      this.getData();
    },
    //`当前页: ${val}`
    handleCurrentChange(val) {
      this.currentPage=val;
      this.getData();
    },
    getData() {
      this.loading = true;
      let param={};
      param.name=this.name;
      param.currentPage=this.currentPage;
      param.pageSize=this.pageSize;
      getList(param).then(({data}) => {
        this.tableData=data.data;
        if(data.page){
          this.currentPage=data.page.pageNo;
          this.pageTotal=data.page.totalRecords;
        }
        this.loading = false;
      }).catch(_ => this.loading = false);
    },
    isEffectiveChange(row) {
      let ename=row.isEffective===0?'禁用':'启用';
      row.loading = true;
      this.$confirm('确定要'+ename+'角色 <'+row.name+'> ?', '提示').then(_ => {
        isEffective(row).then(({data}) => {
          if (data.status) {
            this.$message.success(data.msg);
            this.getData();
          } else {
            row.isEffective = row.isEffective===1 ? 0 : 1;
            this.$message.warning(data.msg);
          }
          row.loading = false;
        }).catch(_ => row.loading = false);
      }).catch(err => {
        row.isEffective = row.isEffective===1 ? 0 : 1;
        console.log('err:', err)
        row.loading = false;
      });
    },
    
    toDeleteRole(row) { // 删除角色
      this.$confirm('确定要删除角色 <'+row.name+'> ？删除后将不能找回！', '提示').then(_ => {
        del(row).then(({data}) => {
          if (data.status) {
            this.$message.success(data.msg);
            this.getData();
          } else {
            this.$message.warning(data.msg);
          }
        }).catch(_ => {})
      }).catch(_ => {})
    },
    
    
  }
})
</script>
<style lang="scss" scoped>
.role-manage-main{
  width: 100%;
  height: 100%;
  .search-main{
    padding: 10px;
    .el-form-item {
        margin-bottom: 0px;
    }
  }
  .table-main{
    padding: 10px;
    height: calc(100% - 130px);
  }
  .pages-main{
    padding: 10px;
  }
}

</style>